export const ExcludeFromLogMetadataKey = Symbol('ExcludeFromLog');

export function ExcludeFromLog() {
  return function (target: object, propertyKey: string) {
    Reflect.defineMetadata(ExcludeFromLogMetadataKey, true, target, propertyKey);
  };
}
